document.addEventListener('DOMContentLoaded', function () {
    const slider = document.getElementById('cmpSlider');
    if (!slider) return;
    if (window.matchMedia('(max-width: 990.98px)').matches) {
        return;
    }

    const viewport = slider.querySelector('.cmp-viewport');
    const dotsWrap = slider.querySelector('.cmp-dots');
    const prevBtn = slider.querySelector('.cmp-arrow--prev');
    const nextBtn = slider.querySelector('.cmp-arrow--next');

    const colW = Number(slider.dataset.colW) || 360;
    const labelW = Number(slider.dataset.labelW) || 280;
    let totalCol = Number(slider.dataset.cols) || 1;

    function visibleCols() {
        const vw = viewport.clientWidth;
        return Math.max(1, Math.floor((vw - labelW) / colW));
    }

    let maxIndex = 0;

    function recalc() {
        maxIndex = Math.max(0, totalCol - visibleCols());
        const pages = maxIndex + 1;

        dotsWrap.innerHTML = '';

        if (pages <= 1) {
            dotsWrap.style.display = 'none';
            prevBtn.style.display = 'none';
            nextBtn.style.display = 'none';
        } else {
            dotsWrap.style.display = 'flex';
            prevBtn.style.display = '';
            nextBtn.style.display = '';
            buildDots(pages);
        }

        update();
    }

    function buildDots(pages) {
        for (let i = 0; i < pages; i++) {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'cmp-dot';
            b.addEventListener('click', () => goTo(i));
            dotsWrap.appendChild(b);
        }
    }


    function goTo(index) {
        const i = Math.max(0, Math.min(index, maxIndex));
        viewport.scrollTo({
            left: i * colW
            , behavior: 'smooth'
        });
    }

    function update() {
        const i = Math.round(viewport.scrollLeft / colW);
        const atStart = i <= 0 || maxIndex === 0;
        const atEnd = i >= maxIndex || maxIndex === 0;

        slider.classList.toggle('is-at-start', atStart);
        slider.classList.toggle('is-at-end', atEnd);

        [...dotsWrap.children].forEach((d, idx) => d.classList.toggle('is-active', idx === i));
    }

    prevBtn.addEventListener('click', () => goTo(Math.round(viewport.scrollLeft / colW) - 1));
    nextBtn.addEventListener('click', () => goTo(Math.round(viewport.scrollLeft / colW) + 1));
    viewport.addEventListener('scroll', () => requestAnimationFrame(update));
    window.addEventListener('resize', recalc);

    recalc();
    update();
});
